import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const StyledVirtualizedRow = styled.tr`
  height: 47.5px;
`;

interface VirtualizedRowProps extends React.PropsWithChildren {
  initiallyRendered?: boolean;
  className?: string;
}

export const VirtualizedRow: React.FC<VirtualizedRowProps> = ({
  children,
  initiallyRendered,
  className,
}) => {
  const rowRef = React.useRef<HTMLTableRowElement>(null);
  const [show, setShow] = useState(initiallyRendered);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setShow(entry.isIntersecting);
        });
      },
      {
        root: null, // Observe relative to the viewport
      },
    );

    if (rowRef.current) {
      observer.observe(rowRef.current);
    }

    return () => {
      if (rowRef.current) {
        observer.unobserve(rowRef.current);
      }
    };
  }, []);

  return (
    <StyledVirtualizedRow ref={rowRef} className={className}>
      {show ? children : null}
    </StyledVirtualizedRow>
  );
};
